webpackJsonp([263791100135453],{

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _colorManipulator = __webpack_require__(55);
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 5
	    },
	    colorPrimary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
	    },
	    colorSecondary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
	    },
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	    query: {
	      transform: 'rotate(180deg)'
	    },
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: 'buffer 3s infinite linear'
	    },
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    bar1Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	    bar2Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	    bar1Determinate: {
	      willChange: 'transform',
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes mui-indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes mui-indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function LinearProgress(props) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
	  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
	  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
	  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    role: "progressbar"
	  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
	    className: dashedClass
	  }) : null, _react.default.createElement("div", {
	    className: bar1ClassName,
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : _react.default.createElement("div", {
	    className: bar2ClassName,
	    style: inlineStyles.bar2
	  }));
	}
	
	LinearProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate or query
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : {};
	LinearProgress.defaultProps = {
	  color: 'primary',
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(158));

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoAndroidCheckmarkCircle = function IoAndroidCheckmarkCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 16.9l5 5 14-13.9 2.3 2.2-16.3 16.3-7.3-7.3z m19.6 3.1h3.3c0 8.9-7.3 16.3-16.2 16.3s-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2c2.1 0 4.2 0.4 6 1.2l-2.5 2.5c-1.1-0.3-2.3-0.5-3.5-0.5-7.2 0-13 5.8-13 13s5.8 13 13 13 12.9-5.8 12.9-13z' })
	        )
	    );
	};
	
	exports.default = IoAndroidCheckmarkCircle;
	module.exports = exports['default'];

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(64);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(127);
	
	var _FormHelperText = __webpack_require__(241);
	
	var _FormHelperText2 = _interopRequireDefault(_FormHelperText);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinearProgress = __webpack_require__(159);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _androidCheckmarkCircle = __webpack_require__(208);
	
	var _androidCheckmarkCircle2 = _interopRequireDefault(_androidCheckmarkCircle);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _app = __webpack_require__(131);
	
	var _regexp = __webpack_require__(290);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _field, _input, _buttonWrapper, _successText;
	
	  return {
	    form: {
	      position: 'relative',
	      '&::after': {
	        clear: 'both'
	      }
	    },
	    field: (_field = {
	      margin: 'auto',
	      maxWidth: '70%'
	    }, _field[theme.breakpoints.down('xs')] = {
	      maxWidth: '100%'
	    }, _field),
	    helperText: {
	      fontSize: '0.9em',
	      marginBottom: 6,
	      textAlign: 'center'
	    },
	    input: (_input = {
	      float: 'left',
	      width: '50%',
	      padding: '0 5px',
	      fontWeight: 500,
	      background: theme.palette.borders.ghost,
	      '& input': {
	        textAlign: 'center',
	        fontWeight: 400
	      },
	      '& input::placeholder': {
	        fontSize: '0.9em',
	        textAlign: 'center',
	        fontWeight: 500,
	        color: '#000'
	      }
	    }, _input[theme.breakpoints.down('xs')] = {
	      width: '100%'
	    }, _input),
	    buttonWrapper: (_buttonWrapper = {
	      float: 'right',
	      width: '50%'
	    }, _buttonWrapper[theme.breakpoints.down('xs')] = {
	      width: '100%'
	    }, _buttonWrapper),
	    button: {
	      fontWeight: 400,
	      background: theme.palette.accent.notice,
	      color: '#fff',
	      boxShadow: 'none',
	      borderRadius: 1,
	      width: '100%',
	      '&:hover': {
	        color: '#000'
	      }
	    },
	    successText: (_successText = {
	      clear: 'both',
	      width: '100%',
	      fontWeight: 500,
	      color: theme.palette.text.main
	    }, _successText[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _successText),
	    checkIcon: {
	      color: theme.palette.successLighter,
	      fontSize: '2.5em'
	    }
	  };
	};
	
	var renderInput = function renderInput(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      customProps = _objectWithoutProperties(_ref, ['input', 'meta']);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Input2.default, _extends({ error: touched && !!error }, input, customProps))
	  );
	};
	
	var AboutSubscribeForm = function AboutSubscribeForm(_ref2) {
	  var classes = _ref2.classes,
	      submitting = _ref2.submitting,
	      handleSubmit = _ref2.handleSubmit,
	      submitSucceeded = _ref2.submitSucceeded;
	
	  var actionProps = {};
	  var oldBrowser = false;
	
	  if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) {
	    actionProps.onSubmit = handleSubmit;
	  } else {
	    oldBrowser = true;
	    actionProps.action = ("https://app.getresponse.com/add_subscriber.html");
	    actionProps.method = 'post';
	  }
	
	  return _react2.default.createElement(
	    'form',
	    _extends({
	      style: { opacity: submitting ? 0.4 : 1 },
	      className: classes.form
	    }, actionProps),
	    _react2.default.createElement(_LinearProgress2.default, {
	      color: 'secondary',
	      style: {
	        position: 'relative',
	        width: '100%',
	        marginBottom: 5,
	        display: submitting ? 'block' : 'none'
	      }
	    }),
	    !submitSucceeded && _react2.default.createElement(
	      'div',
	      { className: classes.field },
	      _react2.default.createElement(
	        _FormHelperText2.default,
	        { className: classes.helperText },
	        'Simply enter your email and click SUBSCRIBE'
	      ),
	      !oldBrowser && _react2.default.createElement(_reduxForm.Field, {
	        classes: { root: classes.input },
	        name: 'email',
	        placeholder: 'EMAIL',
	        component: renderInput,
	        type: 'email',
	        disableUnderline: true,
	        fullWidth: true,
	        required: true
	      }),
	      oldBrowser && _react2.default.createElement(
	        'div',
	        { className: classes.input },
	        _react2.default.createElement(_Input2.default, {
	          name: 'email',
	          placeholder: 'EMAIL',
	          type: 'email',
	          disableUnderline: true,
	          fullWidth: true,
	          required: true
	        })
	      ),
	      oldBrowser && _react2.default.createElement('input', {
	        type: 'hidden',
	        name: 'thankyou_url',
	        value: window.location.href
	      }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'campaign_token', value: '6qdpg' }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.buttonWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            classes: { root: classes.button },
	            variant: 'raised',
	            type: 'submit',
	            size: 'small'
	          },
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'button', style: { color: '#fff' } },
	            'Subscribe'
	          )
	        )
	      )
	    ),
	    submitSucceeded && _react2.default.createElement(
	      _Typography2.default,
	      { align: 'center', className: classes.successText },
	      _react2.default.createElement(_androidCheckmarkCircle2.default, { className: classes.checkIcon }),
	      ' Thank you, you\'re all set.',
	      _react2.default.createElement('br', null)
	    )
	  );
	};
	
	AboutSubscribeForm.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  sendAlert: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles), (0, _reactRedux.connect)(null, { subscribe: _app.subscribe, sendAlert: _app.sendAlert }), (0, _reduxForm.reduxForm)({
	  form: 'SubscribeFormInAboutPage',
	  onSubmit: function onSubmit(_ref3, _, _ref4) {
	    var email = _ref3.email;
	    var subscribeUser = _ref4.subscribe,
	        reset = _ref4.reset,
	        sendAlert = _ref4.sendAlert;
	
	    return new Promise(function (resolve, reject) {
	      var errorMsg = void 0;
	      if (!email) {
	        errorMsg = 'Please provide your email.';
	      }
	      if (!_regexp2.default.email.test(email)) {
	        errorMsg = 'Please provide a valid email.';
	      }
	
	      if (errorMsg) {
	        reject(sendAlert({
	          type: 'error',
	          message: errorMsg
	        }));
	      } else {
	        subscribeUser({ campaignToken: '6qdpg', email: email }).then(function () {
	          sendAlert({
	            message: "You're now subscribed!",
	            type: 'success'
	          });
	          resolve(reset());
	        }).catch(function () {
	          return reject(sendAlert({
	            message: 'The email is either already registered or an error occurred. Please try again later.',
	            type: 'error'
	          }));
	        });
	      }
	    });
	  }
	}))(AboutSubscribeForm);
	module.exports = exports['default'];

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Meta = __webpack_require__(48);
	
	var _Divider = __webpack_require__(212);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _AboutSubscribeForm = __webpack_require__(954);
	
	var _AboutSubscribeForm2 = _interopRequireDefault(_AboutSubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contentWidth = 900;
	var smallContentWidth = '90%';
	
	var styles = function styles(theme) {
	  var _root, _subscribeWrapper, _aboutMessageContaine;
	
	  return {
	    root: (_root = {
	      width: '100%',
	      minHeight: '85vh',
	      padding: '45px 25px'
	    }, _root[theme.breakpoints.down('xs')] = {
	      padding: '45px 0'
	    }, _root),
	    subscribeWrapper: (_subscribeWrapper = {
	      width: contentWidth,
	      margin: 'auto'
	    }, _subscribeWrapper[theme.breakpoints.down('sm')] = {
	      width: smallContentWidth
	    }, _subscribeWrapper),
	    subscribeCallToAction: {
	      padding: '10px 0'
	    },
	    aboutMessageContainer: (_aboutMessageContaine = {
	      width: contentWidth,
	      margin: 'auto'
	    }, _aboutMessageContaine[theme.breakpoints.down('sm')] = {
	      width: smallContentWidth
	    }, _aboutMessageContaine)
	  };
	};
	
	var About = function About(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  var page = data.markdownRemark,
	      siteMetadata = data.site.siteMetadata;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(_Meta.RootMeta, {
	      title: 'About | ' + siteMetadata.siteName,
	      url: siteMetadata.siteUrl,
	      description: siteMetadata.siteDescription,
	      breadCrumb: [{ url: siteMetadata.siteUrl + '/about', name: 'About' }]
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      {
	        spacing: 16,
	        alignItems: 'center',
	        justify: 'center',
	        classes: { container: classes.subscribeWrapper },
	        container: true
	      },
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, item: true },
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            align: 'center',
	            variant: 'title',
	            style: { color: '#666', fontWeight: 500 }
	          },
	          'GET',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            {
	              style: {
	                fontFamily: 'Ruthie',
	                fontSize: '1.5em',
	                textTransform: 'none'
	              }
	            },
	            'updates'
	          )
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'body1',
	            align: 'center',
	            classes: { root: classes.subscribeCallToAction }
	          },
	          'Become a subscriber today to start receiving newsletters of the latest, best trending health content delivered straight to your inbox!'
	        ),
	        _react2.default.createElement(_AboutSubscribeForm2.default, null)
	      )
	    ),
	    _react2.default.createElement(_Divider2.default, null),
	    _react2.default.createElement(
	      _Grid2.default,
	      {
	        spacing: 16,
	        justify: 'center',
	        alignItems: 'center',
	        alignContent: 'center',
	        classes: { container: classes.aboutMessageContainer },
	        container: true
	      },
	      _react2.default.createElement(
	        _Grid2.default,
	        { style: { width: '100%' }, item: true },
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            align: 'center',
	            variant: 'headline',
	            style: { fontWeight: 300 }
	          },
	          'ABOUT'
	        ),
	        _react2.default.createElement(_Typography2.default, {
	          component: 'div',
	          dangerouslySetInnerHTML: { __html: page.html }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        .about-image {\n          object-fit: cover;\n          float: left;\n          width: 100%;\n          max-width: 270px;\n          height: 100%;\n          max-height: 220px;\n          margin: 5px 10px 5px 0;\n        }\n        @media (max-width: 600px) {\n          .about-image {\n            max-width: 100%;\n            float: none;\n          }\n        }\n      '
	    )
	  );
	};
	
	About.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles)(About);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ef3da8a5316581f8b201.js